import React, { useState } from 'react';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import styles from './DropdownSubMenu.module.scss';

export default function DropdownSubMenu(props) {
  const [dropdownOpened, toggleDropdownOpen] = useState(false);
  const { navItem } = props;
  const subMenuItems = navItem.items;
  const inlinePlacementOrderStyle = { order: navItem.navOrder };
  const buttonClasses = [styles.submenuDropdown];

  const subMenuClickHandler = (path) => {
    toggleDropdownOpen(!dropdownOpened);
    props.clickHandler(path);
  };

  if (props.selected) {
    buttonClasses.push(styles.selected);
  }

  return (
    <Dropdown
      direction="right"
      isOpen={dropdownOpened}
      className={buttonClasses.join(' ')}
      style={inlinePlacementOrderStyle}
      toggle={() => toggleDropdownOpen(!dropdownOpened)}
    >
      <DropdownToggle outline caret>
        { props.displayIcon ? <FontAwesomeIcon icon={props.icon} color="grey" size="sm" /> : null }
        {props.label}
      </DropdownToggle>
      <DropdownMenu>
        {
          subMenuItems.map((item) => {
            if (item.type === 'multiple') {
              return (
                <DropdownSubMenu
                  key={item.name}
                  label={item.label}
                  icon={navItem.icon || ''}
                  displayIcon={false}
                  navItem={item}
                  clickHandler={subMenuClickHandler}
                  selected={props.selected}
                  dropdownState={toggleDropdownOpen}
                />
              );
            }
            if (item.type === 'single') {
              return (
                <DropdownItem onClick={() => subMenuClickHandler(item.path)} key={item.label}>
                  {item.label}
                </DropdownItem>
              );
            }

            return null;
          })
        }
      </DropdownMenu>
    </Dropdown>
  );
}
